/**
 * Converts a string into a URL-safe format by replacing spaces, slashes,
 * and other non-alphanumeric characters with hyphens.
 * @param input - The string to be converted.
 * @returns A URL-safe string.
 */
export const toUrlSafeString = (input: string): string => {
  return input
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric characters with hyphens
    .replace(/^-+|-+$/g, ''); // Remove leading or trailing hyphens
};
